import Lookup from 'src/componentes/select2';

const StatusPlanoContingenciaLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/StatusPlanoContingenciaLookup"
    clearable
    {...rest}
  />
);

export default StatusPlanoContingenciaLookup;
